import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.5196 2.00977L3.8125 10.7169L5.22671 12.1311L11.5196 5.83819L11.5196 22.424H13.5196L13.5196 5.83819L19.8125 12.1311L21.2267 10.7169L12.5196 2.00977Z",
		fill: "#395566"
	})
});
export default SvgLine;
